module.exports = __webpack_public_path__ + "static/img/bg_lead.7a8a5cad.png";